// components/ProductGallery.tsx
'use client';
import { useState } from 'react';
import Image from 'next/image';
import { ShoppingBag } from 'lucide-react';

export default function ProductGallery({
	images,
	name,
}: {
		images: { url: string }[];
	name?: string;
}) {
	const [hasError, setHasError] = useState(false);

	if (!images || images.length === 0 || hasError) {
		return (
			<div className="w-full aspect-[4/3] bg-gray-50 rounded-lg flex flex-col items-center justify-center text-gray-400 border border-gray-100 shadow-sm">
				<ShoppingBag className="w-16 h-16 text-gray-300 mb-2" />
				<span className="text-sm font-medium text-gray-400">No Image Available</span>
			</div>
		);
	}

	const displayUrl = images[0]?.url || '';

	return (
		<div className="w-full rounded-lg overflow-hidden shadow-sm bg-white border border-gray-100">
			<img
				src={displayUrl}
				alt={name || 'product image'}
				className="w-full h-auto max-h-[600px] object-contain mx-auto"
				onError={() => setHasError(true)}
			/>
		</div>
	);
}
